/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 29/3/2023
 */


import { Box, Button, Container, Paper, Toolbar, Typography } from "@mui/material"
import { useState } from "react";
import { useDispatch } from "react-redux"
import SearchBar from "../Components/Shared/SearchBar";
import UserDialog from "../Components/User/UserDialog";
import UserList from "../Components/User/UserList";
import { useGetAllUserQuery } from "../Store/Services/UserService";
import { openAddUserModal , closeUserModal } from "../Store/Slices/userSlice";

import styles from "./Management.module.css"

const UserManagement = () => {

    const dispatch = useDispatch();
    const [searchData, setSearchData] = useState([])
    const { data, isSuccess, isLoading } = useGetAllUserQuery();

    const handleClose = () => {
        dispatch(closeUserModal());
    }

    const roles = sessionStorage.getItem("roles");

    return (
        roles?.split(",").includes("PRIV_ES_DISPLAYUSER") ? (
        <Paper elevation={3} className={styles.pageContainer} style={{backgroundImage: `url(${process.env.REACT_APP_IMAGE_URL}E_SERVICE/thumbnail_Management.png)`}}>
            <Box>
                <Toolbar className={styles.subNavBar}>
                    <Typography className={styles.topic}>User Management</Typography>
                    {roles?.split(",").includes("PRIV_ES_ADD_USER") ? (<Button variant="contained" color="primary" className={styles.buttonItem} onClick={() => dispatch(openAddUserModal())}>Add User</Button>) : null}
                </Toolbar>
            </Box>
            <Container id={styles.container}>
                <SearchBar
                    data={isSuccess|| isLoading ? data : []}
                    setSearchData={setSearchData}
                    text="Search Users"
                    search="user"
                />
            </Container>

            <Container>
                {isSuccess && <UserList data={Array.isArray(searchData) && searchData.length > 0 ? searchData : data}/>}
            </Container>

            <UserDialog handleClose={handleClose} />
        </Paper> ) : null
    )
}

export default UserManagement
